import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AutoLogout from './Utils/TokenValidity'
import Inactivity from "./Utils/Inactivity";

export function ProtectedOutlet() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  if (isLoggedIn) {
    return (
      <>
        <Inactivity />
        <AutoLogout />
        <Outlet />
      </>);
  } else {
    return <Navigate to="/" />;
  }
}

export function PublicOutlet() {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const role_name = useSelector((state) => state.auth.user?.data?.body?.data?.role_name)

  useEffect(() => {
    if (isLoggedIn) {
      if (role_name === "SUPER_USER") {
        navigate('/dashboard', { replace: true })
      } else if (role_name === "OFFICE_ADMIN") {
        navigate("/project-listing", { replace: true });
      }
    }
  }, [isLoggedIn, navigate]);
  return !isLoggedIn ? <Outlet /> : null;
}
